(function(){
  var HEX={"rosu":"#C0392B","rosie":"#C0392B","rosii":"#C0392B","roz":"#E48FB6","roz pudrat":"#E9C7D3","auriu":"#C9A85F","aurie":"#C9A85F","gold":"#C9A85F","maro":"#7A4A2B","brown":"#7A4A2B","burgundy":"#6D1F2C","verde":"#1F4A36","verde inchis":"#163527","alb":"#EFE7D6","albe":"#EFE7D6","white":"#EFE7D6","ivoar":"#F2EAD8","argintiu":"#BFC4C7","argintie":"#BFC4C7","silver":"#BFC4C7","albastru":"#3A6EA5","bleu":"#8FB4D6","bleumarin":"#22304A","negru":"#23231F","sampanie":"#E7D9B0","champagne":"#E7D9B0","bej":"#D9C7A8","gri":"#9AA0A0","crem":"#EDE3CF","portocaliu":"#D98032","galben":"#E7C15A","mov":"#7A5A9E","lila":"#B39DDB","rose":"#E6B5A6","turcoaz":"#2FA5A0","fucsia":"#C0397F","cupru":"#B87333","transparent":"#E4E9EB","natur":"#C9B48F","ivory":"#F2EAD8"};
  function norm(s){ return (s||"").trim().toLowerCase().replace(/[ăâ]/g,"a").replace(/[șş]/g,"s").replace(/[țţ]/g,"t").replace(/î/g,"i"); }
  function withCount(base,n){ if(!n) return base; if(/^Set\s+\d/.test(base)) return base; return base.replace(/^Set\s+/,"Set "+n+" "); }
  function hexFor(name){
    var k=norm(name); if(!k) return null;
    if(HEX[k]) return HEX[k];
    var parts=k.split(/[\/,]+/).map(function(x){return x.trim();}).filter(Boolean);
    var cols=parts.map(function(p){return HEX[p];}).filter(Boolean);
    if(cols.length>=2) return "linear-gradient(90deg,"+cols.join(",")+")";
    if(cols.length===1) return cols[0];
    return null;
  }
  /* un card; expus ca window.amcInitCard pentru cardurile adăugate ulterior (amc-colpage.js) */
  function initCard(card){
    if(card.getAttribute("data-sw-init")) return; card.setAttribute("data-sw-init","1");
    var pick=card.getAttribute("data-pick")||"";
    var dataEl=card.querySelector("[data-variants]"), vars=[];
    if(dataEl){ try{ vars=JSON.parse(dataEl.textContent); }catch(e){} }
    if(!vars.length || !pick) return;  // produse simple / o singură valoare -> fără selector (rămâne golul)
    // valori distincte pe axa de selecție (în ordinea variantelor)
    var vals=[]; vars.forEach(function(v){ var x=v[pick]; if(x!=null && vals.indexOf(x)<0) vals.push(x); });
    if(vals.length<2) return;  // un singur model/o singură culoare -> fără buline/pastile
    var swWrap=card.querySelector("[data-swatches]"), szWrap=card.querySelector("[data-sizes]");
    var img=card.querySelector("[data-img] img"), offEl=card.querySelector("[data-off]"), priceEl=card.querySelector("[data-price]"),
        vid=card.querySelector("[data-vid]"), addBtn=card.querySelector("[data-add]"),
        titleA=card.querySelector(".p-name a"), purl=card.getAttribute("data-purl")||"",
        dvId=card.getAttribute("data-dv")||"";
    function byVal(x){ return vars.find(function(v){ return v[pick]===x; }); }
    function priceHTML(v){ return (v.was? '<s class="was">'+v.was+'</s> ':'') + '<span class="now">'+v.pf+'</span>'; }
    function applyVar(v){
      if(!v) return;
      if(img && v.img){ img.setAttribute("src",v.img); img.removeAttribute("srcset"); }
      if(priceEl) priceEl.innerHTML=priceHTML(v);
      if(offEl){ offEl.hidden=!v.off; if(v.off) offEl.textContent="−"+v.off+"%"; }
      if(vid){ vid.value=v.id; vid.setAttribute("data-max", v.max==null ? "" : v.max); }
      if(titleA && purl) titleA.setAttribute("href", purl+"?variant="+v.id);
      if(titleA){ var tb=titleA.getAttribute("data-base"); if(tb!=null){ var suf=titleA.getAttribute("data-suffix"); titleA.textContent=withCount(tb, v.b)+(suf?" "+suf:""); } }
      if(addBtn){ addBtn.disabled=!v.avail; addBtn.textContent=v.avail?"Adaugă în coș":"Stoc epuizat"; }
    }
    // valoarea implicită = cea a variantei afișate server-side (data-dv), altfel prima
    var def=vals[0];
    vars.forEach(function(v){ if(String(v.id)===String(dvId) && v[pick]!=null) def=v[pick]; });
    if(pick==="color" && swWrap){
      vals.forEach(function(c){
        var b=document.createElement("button"); b.type="button"; b.className="card-swatch"+(c===def?" is-on":"");
        b.setAttribute("data-val",c); b.title=c; b.setAttribute("aria-label",c);
        var hx=hexFor(c), vi=(byVal(c)||{}).img;
        if(hx) b.style.background=hx; else if(vi) b.style.backgroundImage="url("+vi+")"; else b.style.background="#CBB79A";
        b.addEventListener("click",function(e){ e.preventDefault(); e.stopPropagation();
          swWrap.querySelectorAll(".card-swatch").forEach(function(s){ s.classList.toggle("is-on", s===b); });
          applyVar(byVal(c)); });
        swWrap.appendChild(b);
      });
      applyVar(byVal(def));
      return;
    }
    if(szWrap){
      vals.forEach(function(s){
        var b=document.createElement("button"); b.type="button"; b.className="card-size"+(s===def?" is-on":"");
        b.setAttribute("data-val",s); b.textContent=s;
        b.addEventListener("click",function(e){ e.preventDefault(); e.stopPropagation();
          szWrap.querySelectorAll(".card-size").forEach(function(x){ x.classList.toggle("is-on", x===b); });
          applyVar(byVal(s)); });
        szWrap.appendChild(b);
      });
      if(szWrap.scrollWidth > szWrap.clientWidth + 2) szWrap.classList.add("has-more");
      applyVar(byVal(def));
    }
  }
  window.amcInitCard=initCard;
  document.querySelectorAll("[data-card]").forEach(initCard);
})();
